// Product data for all 16 Interview Kits and 7 Bundles

export const categories = {
  frontend: { id: 'frontend', name: 'Frontend', icon: '🎨' },
  backend: { id: 'backend', name: 'Backend', icon: '⚙️' },
  database: { id: 'database', name: 'Database', icon: '🗄️' },
  devops: { id: 'devops', name: 'DevOps & Cloud', icon: '☁️' },
  core: { id: 'core', name: 'Core CS', icon: '🧠' },
};

export const kits = [
  // Frontend Kits
  {
    id: 'css-kit',
    slug: 'css',
    name: 'CSS Interview Kit',
    shortName: 'CSS',
    category: 'frontend',
    price: 99,
    questionCount: '130+',
    icon: '🎨',
    description: 'Master CSS layouts, positioning, and responsive design for your frontend interviews.',
    topics: ['Flexbox', 'Grid', 'Box Model', 'Positioning', 'Animations', 'Responsive Design', 'Specificity'],
    highlights: [
      'Visual diagrams for complex layouts',
      'Real interview questions from top companies',
      'Code examples with explanations',
      'Quick reference cheat sheets'
    ],
    gumroadId: 'css-kit',
  },
  {
    id: 'javascript-kit',
    slug: 'javascript',
    name: 'JavaScript Interview Kit',
    shortName: 'JavaScript',
    category: 'frontend',
    price: 99,
    questionCount: '150+',
    icon: '📜',
    description: 'Deep dive into JavaScript concepts that interviewers love to ask about.',
    topics: ['Closures', 'Promises', 'Async/Await', 'Event Loop', 'Prototypes', 'ES6+', 'DOM', "'this' keyword"],
    highlights: [
      'Output-based questions with solutions',
      'Tricky interview scenarios',
      'Code snippets ready to use',
      'Common gotchas explained'
    ],
    gumroadId: 'js-kit',
  },
  {
    id: 'react-kit',
    slug: 'react',
    name: 'React Interview Kit',
    shortName: 'React',
    category: 'frontend',
    price: 99,
    questionCount: '150+',
    icon: '⚛️',
    description: 'Comprehensive React interview preparation covering hooks, state, and performance.',
    topics: ['Hooks', 'State Management', 'Redux', 'Performance', 'React 18', 'Server Components', 'Testing'],
    highlights: [
      'React 18 features covered',
      'Custom hooks examples',
      'Performance optimization patterns',
      'Real-world scenarios'
    ],
    gumroadId: 'react-kit',
  },
  {
    id: 'typescript-kit',
    slug: 'typescript',
    name: 'TypeScript Interview Kit',
    shortName: 'TypeScript',
    category: 'frontend',
    price: 99,
    questionCount: '120+',
    icon: '🔷',
    description: 'Type-safe coding questions and advanced TypeScript patterns for interviews.',
    topics: ['Types', 'Interfaces', 'Generics', 'Utility Types', 'Type Guards', 'Conditional Types'],
    highlights: [
      'Advanced type system concepts',
      'Generic patterns explained',
      'Real codebase examples',
      'Type inference tricks'
    ],
    gumroadId: 'typescript-kit',
  },
  {
    id: 'nextjs-kit',
    slug: 'nextjs',
    name: 'Next.js Interview Kit',
    shortName: 'Next.js',
    category: 'frontend',
    price: 99,
    questionCount: '120+',
    icon: '▲',
    description: 'Modern Next.js concepts including App Router, SSR, and Server Components.',
    topics: ['SSR', 'SSG', 'ISR', 'App Router', 'Server Components', 'API Routes', 'Data Fetching', 'SEO'],
    highlights: [
      'App Router vs Pages Router',
      'Server Components explained',
      'Data fetching patterns',
      'SEO best practices'
    ],
    gumroadId: 'nextjs-kit',
  },

  // Backend Kits
  {
    id: 'nodejs-kit',
    slug: 'nodejs',
    name: 'Node.js Interview Kit',
    shortName: 'Node.js',
    category: 'backend',
    price: 99,
    questionCount: '150+',
    icon: '🟢',
    description: 'Server-side JavaScript mastery with Express.js, APIs, and scaling concepts.',
    topics: ['Event Loop', 'Streams', 'Express.js', 'REST APIs', 'Authentication', 'Middleware', 'Scaling'],
    highlights: [
      'Event loop deep dive',
      'Express.js patterns',
      'Authentication flows',
      'Scaling strategies'
    ],
    gumroadId: 'nodejs-kit',
  },
  {
    id: 'python-kit',
    slug: 'python',
    name: 'Python Interview Kit',
    shortName: 'Python',
    category: 'backend',
    price: 99,
    questionCount: '150+',
    icon: '🐍',
    description: 'Python fundamentals and advanced concepts for backend developer interviews.',
    topics: ['OOP', 'Decorators', 'Generators', 'Data Structures', 'Multithreading', 'Libraries'],
    highlights: [
      'Pythonic code patterns',
      'OOP concepts explained',
      'Concurrency models',
      'Popular library usage'
    ],
    gumroadId: 'python-kit',
  },
  {
    id: 'java-kit',
    slug: 'java',
    name: 'Java Interview Kit',
    shortName: 'Java',
    category: 'backend',
    price: 99,
    questionCount: '150+',
    icon: '☕',
    description: 'Core Java concepts, collections, and modern Java features for interviews.',
    topics: ['OOP', 'Collections', 'Multithreading', 'JVM', 'Garbage Collection', 'Java 8+', 'Streams'],
    highlights: [
      'Collections framework deep dive',
      'Multithreading patterns',
      'JVM internals explained',
      'Java 8+ features'
    ],
    gumroadId: 'java-kit',
  },
  {
    id: 'springboot-kit',
    slug: 'spring-boot',
    name: 'Spring Boot Interview Kit',
    shortName: 'Spring Boot',
    category: 'backend',
    price: 149,
    questionCount: '130+',
    icon: '🍃',
    description: 'Enterprise Java development with Spring Boot, DI, and microservices.',
    topics: ['Annotations', 'DI/IoC', 'REST APIs', 'JPA', 'Security', 'Microservices', 'Actuator'],
    highlights: [
      'Annotation deep dive',
      'Dependency injection patterns',
      'Security configurations',
      'Microservices architecture'
    ],
    gumroadId: 'springboot-kit',
  },

  // Database Kits
  {
    id: 'sql-kit',
    slug: 'sql',
    name: 'SQL Interview Kit',
    shortName: 'SQL',
    category: 'database',
    price: 99,
    questionCount: '150+',
    icon: '🗃️',
    description: 'SQL queries, optimization, and database design for data-driven interviews.',
    topics: ['Joins', 'Subqueries', 'Window Functions', 'CTEs', 'Indexing', 'Optimization', 'Normalization'],
    highlights: [
      'Complex query examples',
      'Performance optimization',
      'Index strategies',
      'Real interview queries'
    ],
    gumroadId: 'sql-kit',
  },
  {
    id: 'mongodb-kit',
    slug: 'mongodb',
    name: 'MongoDB Interview Kit',
    shortName: 'MongoDB',
    category: 'database',
    price: 99,
    questionCount: '120+',
    icon: '🍃',
    description: 'NoSQL database concepts with MongoDB aggregation and schema design.',
    topics: ['CRUD', 'Aggregation Pipeline', 'Indexing', 'Schema Design', 'Replication', 'Sharding'],
    highlights: [
      'Aggregation pipeline mastery',
      'Schema design patterns',
      'Scaling with sharding',
      'Performance tuning'
    ],
    gumroadId: 'mongodb-kit',
  },

  // DevOps & Cloud Kits
  {
    id: 'git-kit',
    slug: 'git',
    name: 'Git Interview Kit',
    shortName: 'Git',
    category: 'devops',
    price: 99,
    questionCount: '100+',
    icon: '🔀',
    description: 'Version control mastery with Git workflows and collaboration patterns.',
    topics: ['Branching', 'Merging', 'Rebasing', 'Workflows', 'Conflict Resolution', 'Hooks'],
    highlights: [
      'Git workflow strategies',
      'Conflict resolution tips',
      'Advanced Git commands',
      'Team collaboration patterns'
    ],
    gumroadId: 'git-kit',
  },
  {
    id: 'aws-kit',
    slug: 'aws',
    name: 'AWS Interview Kit',
    shortName: 'AWS',
    category: 'devops',
    price: 149,
    questionCount: '120+',
    icon: '☁️',
    description: 'Amazon Web Services concepts for cloud infrastructure interviews.',
    topics: ['EC2', 'S3', 'Lambda', 'VPC', 'IAM', 'RDS', 'DynamoDB', 'CloudFormation', 'Architecture'],
    highlights: [
      'Core services explained',
      'Architecture patterns',
      'Security best practices',
      'Cost optimization'
    ],
    gumroadId: 'aws-kit',
  },
  {
    id: 'docker-k8s-kit',
    slug: 'docker-kubernetes',
    name: 'Docker & Kubernetes Interview Kit',
    shortName: 'Docker & K8s',
    category: 'devops',
    price: 149,
    questionCount: '130+',
    icon: '🐳',
    description: 'Containerization and orchestration concepts for DevOps interviews.',
    topics: ['Containers', 'Images', 'Dockerfile', 'Compose', 'Pods', 'Deployments', 'Services', 'Scaling'],
    highlights: [
      'Docker fundamentals',
      'Kubernetes architecture',
      'Deployment strategies',
      'Scaling patterns'
    ],
    gumroadId: 'docker-k8s-kit',
  },

  // Core CS Kits
  {
    id: 'dsa-kit',
    slug: 'dsa',
    name: 'DSA Interview Kit',
    shortName: 'DSA',
    category: 'core',
    price: 149,
    questionCount: '200+',
    icon: '🧮',
    description: 'Data structures and algorithms problems with patterns and solutions.',
    topics: ['Arrays', 'Linked Lists', 'Trees', 'Graphs', 'DP', 'Recursion', 'Sorting', 'Searching', 'Patterns'],
    highlights: [
      '200+ curated problems',
      'Pattern-based approach',
      'Step-by-step solutions',
      'Time/Space complexity analysis'
    ],
    gumroadId: 'dsa-kit',
  },
  {
    id: 'system-design-kit',
    slug: 'system-design',
    name: 'System Design Interview Kit',
    shortName: 'System Design',
    category: 'core',
    price: 149,
    questionCount: '50+',
    icon: '🏗️',
    description: 'Large-scale system design concepts and architectural patterns.',
    topics: ['Scalability', 'Load Balancing', 'Caching', 'Sharding', 'Microservices', '50+ System Designs'],
    highlights: [
      '50+ system designs',
      'Scalability patterns',
      'Real-world architectures',
      'Interview frameworks'
    ],
    gumroadId: 'system-design-kit',
  },
];

export const bundles = [
  {
    id: 'frontend-bundle',
    slug: 'frontend-master',
    name: 'Frontend Master Bundle',
    price: 399,
    originalPrice: 495,
    savings: 96,
    questionCount: '670+',
    kitCount: 5,
    icon: '🎨',
    description: 'Complete frontend interview preparation with CSS, JavaScript, React, TypeScript, and Next.js.',
    includedKits: ['css-kit', 'javascript-kit', 'react-kit', 'typescript-kit', 'nextjs-kit'],
    highlights: [
      'All 5 frontend technologies',
      '670+ interview questions',
      'From basics to advanced',
      'Modern frameworks covered'
    ],
    gumroadId: 'frontend-bundle',
  },
  {
    id: 'backend-bundle',
    slug: 'backend-master',
    name: 'Backend Master Bundle',
    price: 449,
    originalPrice: 596,
    savings: 147,
    questionCount: '720+',
    kitCount: 5,
    icon: '⚙️',
    description: 'Comprehensive backend preparation covering Node.js, Python, Java, SQL, and MongoDB.',
    includedKits: ['nodejs-kit', 'python-kit', 'java-kit', 'sql-kit', 'mongodb-kit'],
    highlights: [
      '5 backend technologies',
      '720+ questions',
      'Multiple languages',
      'Database mastery'
    ],
    gumroadId: 'backend-bundle',
  },
  {
    id: 'devops-bundle',
    slug: 'devops-cloud',
    name: 'DevOps & Cloud Bundle',
    price: 449,
    originalPrice: 546,
    savings: 97,
    questionCount: '400+',
    kitCount: 4,
    icon: '☁️',
    description: 'DevOps and cloud infrastructure preparation with Git, AWS, Docker, and Kubernetes.',
    includedKits: ['git-kit', 'aws-kit', 'docker-k8s-kit', 'system-design-kit'],
    highlights: [
      'Version control to cloud',
      'Container orchestration',
      'System design included',
      'Production-ready skills'
    ],
    gumroadId: 'devops-bundle',
  },
  {
    id: 'java-enterprise-bundle',
    slug: 'java-enterprise',
    name: 'Java Enterprise Bundle',
    price: 449,
    originalPrice: 596,
    savings: 147,
    questionCount: '480+',
    kitCount: 4,
    icon: '☕',
    description: 'Enterprise Java development with Core Java, Spring Boot, SQL, and System Design.',
    includedKits: ['java-kit', 'springboot-kit', 'sql-kit', 'system-design-kit'],
    highlights: [
      'Core Java mastery',
      'Spring Boot expertise',
      'Database fundamentals',
      'Architecture skills'
    ],
    gumroadId: 'java-enterprise-bundle',
  },
  {
    id: 'mern-bundle',
    slug: 'mern-stack',
    name: 'MERN Stack Bundle',
    price: 449,
    originalPrice: 545,
    savings: 96,
    questionCount: '650+',
    kitCount: 5,
    icon: '🚀',
    description: 'Full-stack JavaScript with MongoDB, Express, React, and Node.js plus Git.',
    includedKits: ['javascript-kit', 'react-kit', 'nodejs-kit', 'mongodb-kit', 'git-kit'],
    highlights: [
      'Full MERN stack',
      'Frontend + Backend',
      'Database included',
      'Version control'
    ],
    gumroadId: 'mern-bundle',
  },
  {
    id: 'dsa-system-design-bundle',
    slug: 'dsa-system-design',
    name: 'DSA + System Design Bundle',
    price: 249,
    originalPrice: 298,
    savings: 49,
    questionCount: '250+',
    kitCount: 2,
    icon: '🧠',
    description: 'Core computer science preparation with DSA and System Design.',
    includedKits: ['dsa-kit', 'system-design-kit'],
    highlights: [
      'Problem-solving mastery',
      'Architecture skills',
      'Both coding rounds covered',
      'Essential for FAANG'
    ],
    gumroadId: 'dsa-sd-bundle',
  },
  {
    id: 'complete-bundle',
    slug: 'complete-collection',
    name: 'Complete Collection Bundle',
    price: 999,
    originalPrice: 1749,
    savings: 750,
    questionCount: '2100+',
    kitCount: 16,
    icon: '👑',
    featured: true,
    description: 'Get ALL 16 Interview Kits at the best value. Everything you need to crack any tech interview.',
    includedKits: kits.map(kit => kit.id),
    highlights: [
      'All 16 Interview Kits',
      '2100+ questions',
      'Best value (less than ₹63/kit)',
      'Future updates included'
    ],
    gumroadId: 'complete-bundle',
  },
];

// Helper functions
export const getKitById = (id) => kits.find(kit => kit.id === id);
export const getKitBySlug = (slug) => kits.find(kit => kit.slug === slug);
export const getBundleById = (id) => bundles.find(bundle => bundle.id === id);
export const getBundleBySlug = (slug) => bundles.find(bundle => bundle.slug === slug);
export const getKitsByCategory = (category) => kits.filter(kit => kit.category === category);
export const getKitsForBundle = (bundleId) => {
  const bundle = getBundleById(bundleId);
  if (!bundle) return [];
  return bundle.includedKits.map(kitId => getKitById(kitId)).filter(Boolean);
};

// Stats
export const stats = {
  totalKits: 16,
  totalQuestions: '2100+',
  totalBundles: 7,
  technologies: 16,
};

// FAQs
export const faqs = [
  {
    q: "What format are the kits in?",
    a: "All kits are delivered as well-formatted PDF files for easy reading on any device. You'll also get markdown versions for quick reference.",
  },
  {
    q: "Are these questions from real interviews?",
    a: "Yes! Questions are curated from actual technical interviews at top tech companies including Amazon, Google, Microsoft, Flipkart, Razorpay, Swiggy, and more.",
  },
  {
    q: "How do I access my purchase?",
    a: "After payment, you'll receive an email with download links immediately. No account needed - just check your inbox!",
  },
  {
    q: "Are updates included?",
    a: "Yes! All future updates to your purchased kits are free. We regularly add new questions and improve existing content.",
  },
  {
    q: "Which bundle should I choose?",
    a: "It depends on your target role. Frontend developers should go for Frontend Master, backend developers for Backend Master, and if you want comprehensive preparation, the Complete Collection is the best value.",
  },
];
